import { render, staticRenderFns } from "./Alerts2.vue?vue&type=template&id=52df443f&"
import script from "./Alerts2.vue?vue&type=script&lang=js&"
export * from "./Alerts2.vue?vue&type=script&lang=js&"
import style0 from "./Alerts2.vue?vue&type=style&index=0&id=52df443f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports